import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import NProgress from "nprogress";

interface LoadingScreenProps {
  height?: string | number;
  loadingMessages?: string[];
  dataTestId?: string;
}

const LoadingScreen = ({
  height,
  loadingMessages,
  dataTestId,
}: LoadingScreenProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  }, []);

  useEffect(() => {
    if (loadingMessages && loadingMessages.length > 0) {
      const interval = setInterval(() => {
        setMessageIndex(
          (prevIndex) => (prevIndex + 1) % loadingMessages.length,
        );
      }, 3000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [loadingMessages]);

  const displayText =
    loadingMessages && loadingMessages.length > 0
      ? loadingMessages[messageIndex]
      : null;

  return (
    <Box
      data-testid={dataTestId || "loading-screen"}
      sx={{
        alignItems: "center",
        backgroundColor: "transparent",
        display: "flex",
        flexDirection: "column",
        height: height || "100%",
        justifyContent: "center",
        minHeight: "350px",
        padding: (theme) => theme.spacing(3),
      }}
    >
      <Box width={400}>
        {displayText && <Typography variant="body1">{displayText}</Typography>}
        <LinearProgress />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
